module.exports = __webpack_public_path__ + "static/media/dragonshade-logo.0d3e70fd.svg";